import React, { Component } from 'react';
import {RegWrapper} from './RegWrapper.js'
import axios  from 'axios';
import Cookies from 'universal-cookie';
import {Loader} from './Loader.js';
import VkLogo from './vk_logo.png';
import queryString from 'query-string'


export class VkLogin extends Component {

    state = {
        isSending: false
    }    
    
    constructor(props) {
        super(props)
        this.props = props
        const cookies = new Cookies();
        const value = queryString.parse(window.location.search);
        this.code = value.code;
        if ( (cookies.get('tgsubs_token') != undefined)) {
       
            window.location = '/createwidget'
         }
    }

    

    
    SendLoginRequest = () => {
        const cookies = new Cookies();

       
        
        this.setState((prevState) => {
            return  {
                   isSending : true
               
               };
       }, () =>  {
           
       })
       
       
        axios
        .post(process.env.REACT_APP_BACKEND_SERVER +'/vkLogin/', {
            'code' : this.code,
            
        },
        /* {headers: {
            'Content-Type': 'multipart/form-data'
        }}*/ )
        .then(res => {
           
            
                cookies.set('tgsubs_token', 
                res.data.access,
                 {path : '/'});
            
            
            window.location.href = '/createwidget'
        })
       
           
    }
    

    componentDidMount() {
        this.SendLoginRequest()
    }


    render() {
        return (
            
            <RegWrapper >
            
            <div><h1>Входим...</h1></div>
            <Loader loader={this.state.isSending} />
            

            
      
        </RegWrapper>  

        )
    }

}
